export default "__VITE_ASSET__BZJXkdSw__"